import React from "react";
import { Collapse, Divider, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { MenuLink } from "../Page/MainPageStyles";
import IconExpandLess from '@material-ui/icons/ExpandLess'
import IconExpandMore from '@material-ui/icons/ExpandMore'

function InstyleMenuItem(props) {
    const { label, icon, items = [] } = props
    const [open, setOpen] = React.useState(true)
    const isExpandable = items && items.length > 0

    const onClickHandler = (e) => {
      setOpen(!open)

      if (props.onClick) {
        props.onClick(e);
      }
    }

    const MenuItemRootLink = !isExpandable ? (
      <MenuLink to={props.to} onClick={onClickHandler}>
        <ListItem button>
          <ListItemIcon style={{color:"var(--color-white)"}}>{icon || null}</ListItemIcon>
          <ListItemText primary={label} />
          {isExpandable && !open && <IconExpandMore style={{color:"var(--color-white)"}} />}
          {isExpandable && open && <IconExpandLess style={{color:"var(--color-white)"}} />}
        </ListItem>
      </MenuLink>
    ) : null;

    const MenuItemRoot = isExpandable ? (
      <>
      {isExpandable && open && <Divider style={{backgroundColor: "var(--color-white)"}} />}
      <ListItem button onClick={onClickHandler}>
        <ListItemIcon style={{color:"var(--color-white)"}}>{icon || null}</ListItemIcon>
        <ListItemText primary={label} />
        {isExpandable && !open && <IconExpandMore style={{color:"var(--color-white)"}} />}
        {isExpandable && open && <IconExpandLess style={{color:"var(--color-white)"}} />}
      </ListItem>
      </>
    ) : null;

    const MenuItemChildren = isExpandable ? (
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items.map((item, index) => {
           return <InstyleMenuItem {...item.props} key={`${label}-${index}-menu-item-child`} />
          })}
        </List>
      </Collapse>
    ) : null;

    return(
      <>
        {MenuItemRootLink}
        {MenuItemRoot}
        {MenuItemChildren}
      </>
    )
}

export default InstyleMenuItem;